<template>
    <UnderlinedHeading :route="showLink ? route : null" :linkText="showLink ? linkText : null" class="ph3 ph4-ns bg-near-white">{{text}}</UnderlinedHeading>
</template>

<script>
import UnderlinedHeading from '@/components/controls/UnderlinedHeading.vue';

export default {
    components: {
        UnderlinedHeading
    },
    computed: {
        showLink() {
            var validRoute = true;

            if (this.sizeDependent) {
                if (this.$mq !== 'xs' && this.$mq !== 'sm') {
                    validRoute = false;
                }
            }

            return validRoute;
        }
    },
    props: {
        text: {
            type: String
        },
        route: {
            type: String
        },
        linkText: {
            type: String
        },
        sizeDependent: {
            type: Boolean,
            default: true
        }
    }
};
</script>
